import { render } from 'react-dom'
import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import './styles.css'
import { ProductCarousel } from './ProductCarousel'
import {stockingItems, miniPresents, mediumPresents, largePresents} from './Catalog'
import {MP3Player} from './MP3Player'
import {CouponCode} from './EnterCouponCode'
import Container from '@material-ui/core/Container'
import SweetModal from './SweetModal'
import Card from './Card'
import RedeemIcon from '@material-ui/icons/Redeem';
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import useSound from 'use-sound'
import successSound from './soundEffects/success.mp3'
import errorSound from './soundEffects/error.mp3'
import HoHoHo from './soundEffects/HoHoHo.mp3'
import Wishlist from './Wishlist'
import {firestore} from './firebase'
import Background from './Background'
import { Categories } from './Home'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import {makeStyles} from '@material-ui/core'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import {Loading} from './Loading'

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: 'space-between',
    color: '#272730'
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: '#272730'
  },
  title: {

    color: '#272730',
    fontWeight: 800,
  },
  credit: {
    '&:hover': {
      cursor: 'pointer',
      color: 'white'
    }
  }

}));

export const AppContext = React.createContext({})

function App() {
  const [credit, setCredit] = useState(0)
  const [wishList, setWishList] = useState([])
  const [openCouponCode, setCoupon] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('Something went wrong!')
  const [code, setCode] = useState('')
  const [confirm, setConfirm] = useState(false)
  const [product, setProduct] = useState(false)
  const [checkout, setCheckout] = useState(false)
  const [playSuccess] = useSound(successSound)
  const [playError] = useSound(errorSound)
  const [playHo] = useSound(HoHoHo)


  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#000000',
      },
    },
  });


  const addProductToWishlist = product => {
    if (credit >= product.price) {
      setWishList(x => {
        return [...x, product]
      })
      setCredit(x => x - product.price)
      playSuccess()
    }
    else {
      playError()
      setError(true)
      setMessage("Looks like you don't have enough credit :(")
    }
  }

  let sessionToken = React.useMemo(() => new Date().getTime(), [])

  let contextValues = {
    credit, setCredit, wishList, setWishList, loading, setLoading, setCoupon,
    error, setError, success, setSuccess, message, setMessage, setConfirm, confirm, setProduct, product,
    addProductToWishlist
  }


  const sendWishList = () => {
    setLoading(true)
    setCheckout(false)
    if (wishList.length > 0) {
      firestore.collection('presentLists').doc(sessionToken.toString()).set({
        wishList
      }, {merge: true})
        .then(res => {
          console.log(res)
          setLoading(false)
          setSuccess(true)
          setMessage("Christmas list was sent to the North Pole!" )
          setWishList([])

          playHo()
          playSuccess()
        })
        .catch(err => {
          console.error(err)
          playError()
          setLoading(false)
          setError(true)
          setMessage("OH NO! Something went wrong when trying to send your list off to the north pole. Please wait a few minutes and try again. If the problem persists, just text Marcus.")
        })
    }

  }
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider value={contextValues}>
      <>
        <div className={classes.root}>
          <AppBar position="fixed" style={{backgroundColor: '#BAE9FF'}}>
            <Toolbar>
              <MP3Player/>
              <div style={{paddingLeft: 25, color: '#272730', fontSize: 24}} className={classes.credit}>
                <h4 onClick={() => code === '' ? setCoupon(true):setCoupon(false)}>${credit}</h4>
              </div>
              <div style={{zIndex: 100, paddingLeft: 25}}>
                <IconButton edge='end' color={'inherit'} onClick={() => setCheckout(true)} style={{color: 'black'}}>
                  <Badge badgeContent={wishList.length} color={'primary'}>
                    <RedeemIcon/>
                  </Badge>
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
        </div>
        <Background/>
        <div style={{position: 'relative', top: 0, height: '100vh', width:'100vw', color: 'white', display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
          <div className={'text'}>
          <h1>
            Callie's
          </h1>
          <h1>
            Christmas
          </h1>
          <h1>
            Catalog
          </h1>
            <Typography align={'center'} style={{color:'black'}}>🎄🎁🎅☃️</Typography>
            <div className={'jumbo'} style={{paddingTop: 40}}>
              <Categories/>
            </div>
          </div>
        </div>

        <SweetModal open={error} onConfirm={() => setError(false)} title={'Oh NO!'} component={<h2>{message}</h2>} type={'error'}/>
        <SweetModal open={success} onCancel={() => setSuccess(false)} onConfirm={() => setSuccess(false)} title={'Success!'} component={<h2>{message}</h2>} type={'success'}/>
        <SweetModal open={checkout} onCancel={() => setCheckout(false)} onConfirm={sendWishList} title={'Christmas List 🎅'} component={<Wishlist {...contextValues}/> } fullScreen buttonText={'Send List to the north pole!'}/>
        <SweetModal open={openCouponCode} onConfirm={() => {
          if (code.toLowerCase() === 'marcusisthebest') {
            setCoupon(false)
            setCredit(140)
            playSuccess()
          }
          else {
            setCode('')
            setError(true)
            setMessage("The coupon code you entered is invalid. Please try again and get it right this time.")
          }


          setCoupon(false)
        }} title={'Enter in Your Coupon Code'} component={<CouponCode code={code} setCode={setCode}/>}/>
        <SweetModal open={confirm} onCancel={() => setConfirm(false)} title={'Add to christmas list for $' +  product.price + '?' } buttonText={"Add to christmas list!"} onConfirm={() => {
          setConfirm(false)
          addProductToWishlist(product)

        }} component={<>
          <Card {...product} noStyle/>
        </>

          }/>
          <Container maxWidth={'lg'} style={{marginTop: '2rem', paddingBottom: '110vh'}}>
            <Grid container spacing={5} justify={'center'} alignContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <h2>🎄$5</h2>
            <ProductCarousel presents={stockingItems} price={5} {...contextValues}/>
            </Grid>
              <Grid item xs={12}>
            <h2>🎄$10</h2>
            <ProductCarousel presents={miniPresents} price={10} {...contextValues}/>
              </Grid>
              <Grid item xs={12}>
            <h2>🎄$25</h2>
            <ProductCarousel presents={mediumPresents} price={25} {...contextValues}/>
              </Grid>
              <Grid item xs={12}>
            <h2>🎄$100</h2>
            <ProductCarousel presents={largePresents} price={100} {...contextValues}/>
              </Grid>
            </Grid>
          </Container>
        <div className={'bottomText'}>
          <Typography variant={'h6'} align={'center'}><a style={{fontSize: 10}}>p.s.</a>You're really cute</Typography>
        </div>
        <Loading/>
      </>
      </AppContext.Provider>
    </ThemeProvider>
  )
}

render(<App />, document.querySelector('#root'))
